  <div class="filter-builder-container"
       [ngClass]="{'form-layout-compact': useCompactFormLayout}">
    <div class="row">
      <div class="field">
        <input soho-radiobutton type="radio" soho-trackdirty name="optionsConditionGroupMatch" id="optionsConditionGroupMatchAll" value="all" [(ngModel)]="model.matchOption" (change)="onMatchChange($event)" data-automation-id="lm-filter-builder-match-all"/>
        <label for="optionsConditionGroupMatchAll" class="radio-label" data-automation-id="lm-filter-builder-match-all-label">{{ 'CreateReportMatchAllLabel' | translate }}</label>
        <input soho-radiobutton type="radio" soho-trackdirty name="optionsConditionGroupMatch" id="optionsConditionGroupMatchAny" value="any" [(ngModel)]="model.matchOption" (change)="onMatchChange($event)" data-automation-id="lm-filter-builder-match-any"/>
        <label for="optionsConditionGroupMatchAny" class="radio-label" data-automation-id="lm-filter-builder-match-any-label">{{ 'CreateReportMatchAnyLabel' | translate }}</label>
      </div>
    </div>
  
    <div class="row field-short">
      <h3>{{ 'Conditions' | translate }}</h3>
    </div>
    <ng-container *ngFor="let data of filterRows; index as i; first as isFirst; last as isLast">
      <lm-filter-builder-row
              [filterRow] = "data"
              [businessClass] = "businessClass"
              [lookupUrl] = "lookupUrl"
              [fieldSearchUrl]="fieldSearchUrl"
              [lplValidationUrl]="lplValidationUrl"
              [includeAuditFields]="includeAuditFields"
              [index] = "i"
              (onRemoveRowEvent)="onRemoveButtonEvent($event, i)"
      >
      </lm-filter-builder-row>
      <ng-container *ngIf="filterRows.length > 1 && !isLast">
        <div class="flex-separator-container">
            <div class="flex-separator-column"><hr></div>
            <p class="and-separator lm-bold">{{separator}}</p>
            <div class="flex-separator-column"><hr></div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="buildAnother-btn">
    <button 
      soho-button="primary"
      (click)="onAddButtonEvent($event)"
      soho-alert
      data-automation-id="lm-filter-builder-build-another"
    >{{ 'BuildAnother' | translate }}</button>
  </div>
